import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  LinearProgress,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Delete,
  Edit,
  ExpandMore,
  Star,
  Visibility,
} from '@mui/icons-material';
import {
  DataGrid,
  GridColumnMenuContainer,
  GridActionsCellItem,
  GridFilterMenuItem,
} from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { toastWarning } from 'utils/toast';
import {
  checkInfosProduto,
  CustomPagination,
  encryptURL,
} from 'utils/functions';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { useDialog, useDrawer } from 'components/Modals';
import ProdutoModal from 'components/Modals/ProdutoModal';
import Card from 'components/Card';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import ButtonMenu from 'components/ButtonMenu';
import VirtualDrop from 'components/VirtualDrop';
import localeText from 'utils/localeText';
import Blank from 'assets/blank.png';
import styles from '../styles';

const DataGridColumnMenu = (props) => (
  <GridColumnMenuContainer {...props}>
    <GridFilterMenuItem
      column={props.currentColumn}
      onClick={props.hideMenu}
    />
  </GridColumnMenuContainer>
);

const Itens = ({
  drops,
  onSubmit,
  onDelete,
  documento = {},
  disableActions,
}) => {
  const { openDrawer } = useDrawer();
  const { openDialog } = useDialog();
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const rotina = 'DocumentoItem';

  const Modal = ({ item }) => {
    const [additionals, setAdditionals] = useState(null);
    const [additionalLoading, setAdditionalsLoading] = useState(false);
    const { postLoading } = useContext(DocumentosContext);
    const defaultValues = {
      id: item?.id,
      documento_id: documento?.id,
      produto_id: item?.produto_id || null,
      descricao: item?.descricao || '',
      quantidade: item?.quantidade || '',
      unidade_medida_id: item?.unidade_medida_id || null,
      referencia: item?.referencia || '',
      preco: item?.preco || '',
      desconto1_pc: item?.desconto1_pc || '',
      desconto_vlr: item?.desconto_vlr || '',
      przent: item?.przent || null,
      planoconta_id: item?.planoconta_id || null,
      ccusto_id: item?.ccusto_id || null,
      aplicacao_id: item?.aplicacao_id || null,
      frota_id: item?.frota_id || null,
      infadc: item?.infadc || '',
    };
    const { control, handleSubmit, setValue, watch } = useForm({
      defaultValues,
    });

    const getTotal = () =>
      (watch('quantidade') || 1) * watch('preco') + watch('desconto_vlr');

    useEffect(() => {
      const desconto_vlr =
        watch('desconto1_pc') * watch('preco') * watch('quantidade');
      setValue(
        'desconto_vlr',
        desconto_vlr !== 0 ? desconto_vlr * -0.01 : desconto_vlr
      );
    }, [watch('desconto1_pc'), watch('preco'), watch('quantidade')]);

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={2}>
            {!Boolean(item) &&
              (Boolean(documento?.Especie?.natureza === 'COMPRA') ||
                Boolean(documento?.Especie?.natureza === 'ORCAMENTO')) && (
                <Grid item xs={12} textAlign="center">
                  <ButtonMenu buttonProps={{ variant: 'outlined' }} />
                </Grid>
              )}
            <Grid item xs={12}>
              <VirtualDrop
                busca_refinada
                name="produto_id"
                control={control}
                label="Produto"
                options={drops?.Produto}
                onValueChange={async (p) => {
                  setAdditionals(null);
                  if (
                    p?.value &&
                    !(Boolean(item?.id) && !Boolean(item?.produto_id))
                  ) {
                    try {
                      setAdditionalsLoading(true);
                      const produto = await checkInfosProduto({
                        disponivel: 'SIM',
                        produto_id: p?.value,
                        filial_id: documento?.filial_id,
                        cadastro_id: documento?.cadastro_id,
                      });
                      setValue('descricao', produto?.descricao);
                      setValue('quantidade', 1);
                      setValue('unidade_medida_id', produto?.unidade_medida_id);
                      setValue('referencia', produto?.referencia);
                      setValue('preco', produto?.custo);
                      setAdditionals({
                        saldo: produto?.saldo,
                        referencia: produto?.referencia,
                        localizador: produto?.localizador,
                        imagem: produto?.imagem,
                      });
                    } catch (error) {
                    } finally {
                      setAdditionalsLoading(false);
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input name="descricao" control={control} label="Descrição" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Input
                name="quantidade"
                control={control}
                label="Quantidade"
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Dropdown
                name="unidade_medida_id"
                control={control}
                label="Unidade de Medida"
                options={drops?.UnidadeMedida}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Input name="referencia" control={control} label="Referência" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputMask
                name="desconto1_pc"
                control={control}
                label="% Desconto"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputMask
                name="preco"
                control={control}
                label="Preço Unitário"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputMask
                name="przent"
                control={control}
                label="Prazo de Entrega"
                type="date"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="planoconta_id"
                control={control}
                label="Plano de Conta"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="ccusto_id"
                control={control}
                label="Centro de Custo"
                options={drops?.Ccusto}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="aplicacao_id"
                control={control}
                label="Aplicação"
                options={drops?.Aplicacao}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Dropdown
                name="frota_id"
                control={control}
                label="Frota"
                options={drops?.Frota}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                name="infadc"
                control={control}
                label="Informações Adicionais"
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" component="div" align="center">
                Total:{' '}
                {getTotal()?.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {Boolean(watch('produto_id')) && Boolean(additionals) && (
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  component="img"
                  sx={styles.image}
                  src={additionals?.imagem || Blank}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" component="div" align="center">
                  Saldo: {additionals?.saldo || '0'}{' '}
                  {additionals?.UnidadeMedida?.descricao || ''}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" component="div" align="center">
                  Referência: {additionals?.referencia || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" component="div" align="center">
                  Localização: {additionals?.localizador || '-'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit((data) => onSubmit({ Itens: [data] }))}
            loading={postLoading || additionalLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const MultiModal = ({ itens = [] }) => {
    const { postLoading } = useContext(DocumentosContext);
    const defaultValues = {
      planoconta_id: null,
      ccusto_id: null,
      aplicacao_id: null,
      frota_id: null,

      cfo_id: null,

      przent: null,
      pedcomp: null,
      comissao_pc: '',
    };
    const { control, handleSubmit } = useForm({ defaultValues });

    const onConfirm = ({
      planoconta_id,
      ccusto_id,
      aplicacao_id,
      frota_id,
      cfo_id,
      przent,
      pedcomp,
      comissao_pc,
    }) => {
      const Itens = itens?.map((i) => ({
        id: i?.id,
        documento_id: i?.documento_id,
        ...(Boolean(planoconta_id) && { planoconta_id }),
        ...(Boolean(ccusto_id) && { ccusto_id }),
        ...(Boolean(aplicacao_id) && { aplicacao_id }),
        ...(Boolean(frota_id) && { frota_id }),
        ...(Boolean(cfo_id) && { cfo_id }),
        ...(Boolean(przent) && { przent }),
        ...(Boolean(pedcomp) && { pedcomp }),
        ...(Boolean(comissao_pc) && { comissao_pc }),
      }));

      onSubmit({ Itens });
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6">Produtos Selecionados</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {itens?.map((i) => (
                <Box my={1}>
                  <Typography variant="caption">
                    • {i?.referencia} - {i?.descricao}
                  </Typography>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="planoconta_id"
            control={control}
            label="Plano de Conta"
            options={drops?.Planoconta?.filter((p) => p?.operacional === 'SIM')}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="ccusto_id"
            control={control}
            label="Centro de Custo"
            options={drops?.Ccusto}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="aplicacao_id"
            control={control}
            label="Aplicação"
            options={drops?.Aplicacao}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="frota_id"
            control={control}
            label="Frota"
            options={drops?.Frota}
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            name="cfo_id"
            control={control}
            label="CFOP"
            options={drops?.Cfo}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="przent"
            control={control}
            label="Prazo de Entrega"
            type="date"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input name="pedcomp" control={control} label="Pedido de Compra" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="comissao_pc"
            control={control}
            label="% de Comissão"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onConfirm)}
            loading={postLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const options = [
    {
      name: 'Adicionar Item',
      icon: 'add',
      action: () => openDialog(<Modal />, 'Adicionar Item'),
    },
    {
      name: 'Editar Selecionados',
      icon: 'edit',
      action: () => {
        if (Boolean(selected?.length)) {
          openDialog(<MultiModal itens={selected} />, 'Editar Itens');
        } else {
          toastWarning('Selecione ao menos um item');
        }
      },
    },
  ];

  const Line = ({ value, label, type }) => (
    <Grid item xs={12} sm={6}>
      <Box display="flex" alignItems="center">
        {Boolean(type) ? (
          <Typography
            sx={disableActions ? styles?.lineLabel : styles?.lineLabelLink}
            variant="subtitle2"
            onClick={() => {}}
          >
            {label}:
          </Typography>
        ) : (
          <Typography sx={styles?.lineLabel} variant="subtitle2">
            {label}:
          </Typography>
        )}
        <Typography sx={styles?.lineValue} variant="body2">
          {value}
        </Typography>
      </Box>
    </Grid>
  );

  const getItemDetails = (item) => {
    const origem = {
      value: Boolean(item?.DocumentoItemOrigems?.length)
        ? item?.DocumentoItemOrigems[0]?.documento_origem || 'Nº não informado'
        : null,
      hint: item?.DocumentoItemOrigems?.[0]?.especie_origem,
    };
    const vinculo = {
      value: Boolean(item?.Vinculados?.length)
        ? item?.Vinculados[0]?.documento_vinculado || 'Nº não informado'
        : null,
      hint: item?.Vinculados?.[0]?.especie_vinculado,
    };

    return { origem, vinculo };
  };

  const HintCell = ({ value }) => {
    if (!value?.hint) {
      return value?.value || '';
    }

    return (
      <Tooltip placement="left" title={value?.hint}>
        <Typography variant="body2">{value?.value}</Typography>
      </Tooltip>
    );
  };

  const handleSelectionChange = (ids = []) => {
    if (!ids?.length) {
      setSelected([]);
      return;
    }

    const currentIds = selected?.map((item) => item?.id);
    const addedIds = ids?.filter((id) => !currentIds?.includes(id));

    if (!addedIds?.length) {
      setSelected(
        selected?.filter((item) => ids?.some((id) => id === item?.id))
      );
      return;
    }

    const addedItems = documento?.DocumentoItems?.filter((item) =>
      addedIds?.some((id) => id === item?.id)
    );
    const kitIds = addedItems?.map((item) => item?.kit_id)?.filter(Boolean);
    const nextSelected = [
      ...selected?.filter((item) => !kitIds?.includes(item?.kit_id)),
      ...addedItems?.filter((item) => !item?.kit_id),
      ...documento?.DocumentoItems?.filter((item) =>
        kitIds?.includes(item?.kit_id)
      ),
    ];

    setSelected(
      nextSelected?.filter(
        (item, index, self) =>
          index === self?.findIndex((current) => current?.id === item?.id)
      )
    );
  };

  const itemColumns = useMemo(() => {
    const getActionsColumnWidth = (count) =>
      count * 30 + Math.max(count - 1, 0) * 8 + 24;
    const actionsColumnWidth = getActionsColumnWidth(disableActions ? 1 : 3);
    const columns = [
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Ações',
        align: 'left',
        headerAlign: 'center',
        width: actionsColumnWidth,
        minWidth: actionsColumnWidth,
        maxWidth: actionsColumnWidth,
        getActions: ({ row }) => {
          const actions = [];

          if (!disableActions) {
            actions.push(
              <GridActionsCellItem
                icon={<Edit />}
                label="Editar"
                onClick={() => openDialog(<Modal item={row} />, 'Editar Item')}
              />,
              <GridActionsCellItem
                icon={<Delete />}
                label="Excluir"
                onClick={() => onDelete({ rotina, id: row?.id })}
              />
            );
          }

          actions.push(
            // <GridActionsCellItem
            //   icon={<Star />}
            //   label="Qualidade"
            //   onClick={() =>
            //     navigate(
            //       `/app/Documento/Qualidade/${encryptURL({ item_id: row?.id })}`
            //     )
            //   }
            // />,
            <GridActionsCellItem
              icon={<Visibility />}
              label="Detalhes"
              onClick={() =>
                navigate(`/app/Documento/Item`, {
                  state: { item: row, disableActions },
                })
              }
            />
          );

          return actions;
        },
      },
      { field: 'sequencia', headerName: 'Sequencia', width: 110 },
      { field: 'produto_id', headerName: 'Código do Produto', width: 150 },
      {
        field: 'descricao',
        headerName: 'Produto',
        minWidth: 400,
        flex: 1,
        renderCell: ({ row }) => (
          <Typography
            variant="body2"
            onClick={() =>
              openDrawer(<ProdutoModal item={row} />, row?.descricao)
            }
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
              whiteSpace: 'normal',
            }}
          >
            {row?.descricao}
          </Typography>
        ),
      },
      {
        field: 'produto_referencia',
        headerName: 'Referência',
        width: 150,
        valueGetter: ({ row }) => row?.Produto?.referencia,
      },
      {
        field: 'referencia',
        headerName: 'Referência do Fornecedor',
        width: 210,
      },
      ...(!disableActions
        ? [{ field: 'saldo', headerName: 'Saldo', width: 110 }]
        : []),
      {
        field: 'quantidade',
        headerName: 'Quantidade',
        width: 140,
        valueGetter: ({ row }) =>
          `${row?.quantidade || 0} ${row?.UnidadeMedida?.sigla || ''}`,
      },
      {
        field: 'origem',
        headerName: 'Origem',
        width: 160,
        valueGetter: ({ row }) => getItemDetails(row).origem,
        renderCell: ({ value }) => <HintCell value={value} />,
      },
      ...(documento?.NaturezaOperacao?.vinculo === 'SIM'
        ? [
            {
              field: 'vinculo',
              headerName: 'Vínculo',
              align: 'center',
              headerAlign: 'center',
              width: 160,
              valueGetter: ({ row }) => getItemDetails(row).vinculo,
              renderCell: ({ value }) => <HintCell value={value} />,
            },
          ]
        : [])
    ];

    return columns;
  }, [disableActions, documento, selected]);

  return (
    <>
      <Card title="Itens" style={styles?.card}>
        <Grid container spacing={2}>
          {!disableActions && (
            <Grid item xs={12} textAlign="center">
              <ButtonMenu
                buttonProps={{ variant: 'outlined' }}
                options={options}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <DataGrid
              rows={documento?.DocumentoItems || []}
              columns={itemColumns}
              checkboxSelection
              autoHeight
              density="compact"
              disableSelectionOnClick
              showCellRightBorder
              showColumnRightBorder
              getRowHeight={() => 'auto'}
              selectionModel={selected?.map((item) => item?.id)}
              onSelectionModelChange={handleSelectionChange}
              localeText={localeText}
              components={{
                ColumnMenu: DataGridColumnMenu,
                Pagination: CustomPagination,
                LoadingOverlay: LinearProgress,
              }}
            />
          </Grid>
        </Grid>
      </Card>
      <Card title="Totais" style={styles?.card}>
        <Grid container spacing={2}>
          <Line value={documento?.Totais?.peso || 0} label="Peso" />
          <Line value={documento?.Totais?.volume || 0} label="Volume" />
          <Line
            value={(documento?.Totais?.preco || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Preço"
          />
          <Line
            value={(documento?.Totais?.frete || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Frete"
            type="frete"
          />
          <Line
            value={(documento?.Totais?.desconto || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Desconto"
            type="desconto_vlr"
          />
          <Line
            value={(documento?.Totais?.seguro || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Seguro"
            type="seguro"
          />
          <Line
            value={(documento?.Totais?.despac || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Despesas Acessórias"
            type="despac"
          />
          <Line
            value={(documento?.Totais?.outros || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Outros"
            type="outros"
          />
          <Line
            value={(documento?.Totais?.eventuais || 0)?.toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
            label="Eventuais"
            type="eventuais"
          />
          <Line
            value={(documento?.Totais?.impostos || 0)?.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            label="Impostos"
          />
          <Grid item xs={12}>
            <Typography variant="h6" align="center">
              Total:{' '}
              {(documento?.Totais?.documento || 0)?.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default Itens;
